<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">
      {{'account_creation.header' | translate}}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeLogin()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">
    <form [formGroup]="form" (submit)="checkLogin()">
      
      <div class="select-group">
        <label class="sub-label-form-control">{{'account_creation.subTitle' | translate}}</label>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.firstName' | translate}}</label>
        <ion-input class="bordered-input" type="text" formControlName="firstName">
        </ion-input>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.lastName' | translate}}</label>
        <ion-input class="bordered-input" type="text" formControlName="lastName">
        </ion-input>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'login_page.email' | translate}}</label>
        <label class="sub-label-form-control">{{'login_page.email_format' | translate}}</label>
        <ion-input class="bordered-input" required="true" formControlName="email"
        [class.invalid]="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <ion-icon slot="start" name="mail-outline" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide">
            <!-- <ion-icon slot="end" name="info" aria-hidden="true"></ion-icon> -->
            <ion-icon class="invalid" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)" slot="icon-only" name="information-circle-outline" aria-hidden="true"></ion-icon>
          </ion-button>
        </ion-input>
        <div class="custom-error" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <span>{{'login_page.email_format_error' | translate}}</span>
        </div>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.country' | translate}}</label>
        <ion-select formControlName="country" interface="popover" class="styled-select"
          cssClass="select-popover" placeholder="Select country">

          <!-- Start icon -->
          <ion-icon slot="start" name="globe-outline" aria-hidden="true"></ion-icon>

          <!-- Options -->
          <ion-select-option
            *ngFor="let country of countries"
            [value]="country">
            {{ country.name | translate}}
          </ion-select-option>

        </ion-select>

      </div>
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.company' | translate}}<label class="sub-label-form-control">{{'account_creation.optional' | translate}}</label></label>
        <ion-input class="bordered-input" type="text" formControlName="company">
        </ion-input>
      </div>

      <div class="select-group">
        <label class="label-form-control">{{'account_creation.password' | translate}}</label>
        <span class="password-hint">
          It must contain at least:
          <span
            [class.valid]="password?.value && !password?.hasError('minLength')">
            8 characters,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('lowercase')">
            a lowercase letter,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('uppercase')">
            an uppercase letter,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('number')">
            a number,
          </span>

          <span
            [class.valid]="password?.value && !password?.hasError('containsName')">
            no part of your name
          </span>
        </span>


        <ion-input
          class="bordered-input"
          formControlName="password" [type]="showPassword ? 'text' : 'password'">
          <ion-icon slot="start" name="lock-closed" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide" (click)="togglePassword()">
            @if (showPassword) {
              <ion-icon slot="icon-only" name="eye-off" aria-hidden="true" style="color: gray"></ion-icon>
            } @else {
              <ion-icon slot="icon-only" name="eye" aria-hidden="true" style="color: gray"></ion-icon>
            }
          </ion-button>
        </ion-input>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'account_creation.confirmPassword' | translate}}</label>
        <ion-input class="bordered-input" 
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword">
          <ion-icon slot="start" name="lock-closed" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide" (click)="toggleConfirmPassword()">
            @if (showConfirmPassword) {
              <ion-icon slot="icon-only" name="eye-off" aria-hidden="true" style="color: gray"></ion-icon>
            } @else {
              <ion-icon slot="icon-only" name="eye" aria-hidden="true" style="color: gray"></ion-icon>
            }
          </ion-button>
        </ion-input>
      </div>
      <div class="select-group">
        <ion-checkbox labelPlacement="end" formControlName="policy">I have read and accept <a href="#" (click)="$event.stopPropagation()">privacy policy</a></ion-checkbox>
      </div>
    </form>

  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
    <!-- Button Container -->
    <div class="button-container">
      <ion-button fill="outline" class="cancel-btn" (click)="closeLogin()" expand="block">
        {{'cancel' | translate}}
      </ion-button>
      <ion-button class="next-btn" (click)="validate()" [disabled]="!selectedOption" expand="block">
        {{'validate' |translate}}
      </ion-button>
    </div>
</ion-footer>
